// extracted by mini-css-extract-plugin
export default {"container":"layers-control_container__PH7kw plainBackgroundColor","smooth-appear":"layers-control_smooth-appear__-NqTT","collapsed":"layers-control_collapsed__09lSR"};